import { IClassname } from '@/lib/shared/model/classname';

export const Kettle = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14249_7676)">
        <path
          d="M3.85986 26.8623H24.3065V29.4181C24.3065 29.7571 24.1719 30.0821 23.9322 30.3218C23.6926 30.5614 23.3675 30.6961 23.0286 30.6961H5.13778C4.79886 30.6961 4.47381 30.5614 4.23416 30.3218C3.9945 30.0821 3.85986 29.7571 3.85986 29.4181V26.8623Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.9985 10.4216C22.7897 9.95028 23.6824 9.67585 24.6017 9.62139C25.521 9.56694 26.4399 9.73405 27.2812 10.1087C28.1224 10.4833 28.8614 11.0545 29.4359 11.7742C30.0105 12.4939 30.4038 13.341 30.5827 14.2443C30.7617 15.1477 30.7211 16.0808 30.4644 16.9652C30.2077 17.8495 29.7423 18.6593 29.1074 19.3264C28.4726 19.9935 27.6868 20.4984 26.8162 20.7985C25.9456 21.0987 25.0156 21.1854 24.1045 21.0513"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.85979 26.8619C3.82506 23.1188 4.15763 19.3813 4.85273 15.7032C4.94925 15.2294 4.90975 14.738 4.73879 14.2857C4.56783 13.8335 4.2724 13.4388 3.88662 13.1473L1.55954 11.3991C1.45225 11.3187 1.37301 11.2065 1.33302 11.0785C1.29303 10.9505 1.29434 10.8131 1.33674 10.6859C1.37915 10.5587 1.46052 10.448 1.56931 10.3696C1.6781 10.2912 1.80881 10.249 1.94291 10.249H21.9295C23.6292 14.4406 24.3065 20.3318 24.3065 26.8619H3.85979Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.361 3.96689V2.58163C15.361 2.2427 15.2264 1.91766 14.9867 1.678C14.7471 1.43835 14.422 1.30371 14.0831 1.30371C13.7442 1.30371 13.4191 1.43835 13.1795 1.678C12.9398 1.91766 12.8052 2.2427 12.8052 2.58163V3.98734C10.0359 4.52406 7.9376 6.81537 6.47949 10.2491H21.9295C20.5225 6.76936 18.3973 4.46655 15.361 3.96689Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5273 18.5563C11.5273 20.0814 11.7966 21.5441 12.2759 22.6226C12.7552 23.701 13.4053 24.3069 14.0832 24.3069C14.761 24.3069 15.4111 23.701 15.8904 22.6226C16.3697 21.5441 16.639 20.0814 16.639 18.5563C16.639 17.0311 16.3697 15.5684 15.8904 14.49C15.4111 13.4115 14.761 12.8057 14.0832 12.8057C13.4053 12.8057 12.7552 13.4115 12.2759 14.49C11.7966 15.5684 11.5273 17.0311 11.5273 18.5563Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14249_7676">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
